import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonFieldService} from "../../../../../../services/common/common-field.service";
import {AllocationRequest} from "../../../../../../model/clearing/allocation/allocation-request";
import {AccountType} from "../../../../../../model/exchange/account-type";
import {ClearingAllocationService} from "../../../../../../services/clearing/clearing-allocation.service";
import {SingleAllocationFormBaseComponent} from "../single-allocation-form-base.component";
import {ClearingSelectionInfo} from "../../../../../../model/clearing/clearing-selection-info";
import {ClearingTradeInfoService} from "../../../../../../services/clearing/clearing-trade-info.service";
import {ClearingInfoLoadRequest} from "../../../../../../model/clearing/clearing-info-load-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../../../../model/api/api-validation";
import {ClearingSelectionSummary} from "../../../../../../model/clearing/clearing-selection-summary";
import {AppConfigService} from "../../../../../../services/app-config.service";
import {CcStorageService} from "../../../../../../services/common/cc-storage.service";
import {FieldsService} from "../../../../../../services/common/fields-service";

@Component({
  selector: 'app-clearing-single-allocation-form',
  templateUrl: './single-allocation-form.component.html',
  styleUrls: ['../allocation-form-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SingleAllocationFormComponent extends SingleAllocationFormBaseComponent {

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              allocationService: ClearingAllocationService,
              commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private clearingTradeInfoService: ClearingTradeInfoService,
              storageService: CcStorageService,
              fieldsService: FieldsService) {
    super(el, cdref, allocationService,
      commonFieldService, appConfigService, messageService, confirmationService, translateService, storageService,
      fieldsService);
    this.formRecord = new AllocationRequest();
  }

  protected initConfigs() {
    super.initConfigs();
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.single_allocation');
  }

  public open(selectedIds: string[], clearingSelectionInfos: ClearingSelectionInfo[]): void {
    // if (selectedIds && selectedIds.length > 0) {
    const allocationInProgress = new AllocationRequest();
    allocationInProgress.accountTypeCode = AccountType.GIVE_UP_CODE;
    allocationInProgress.tradeIds = selectedIds;
    if (clearingSelectionInfos.length > 0) {
      const clearingSelectionInfo = clearingSelectionInfos[0];
      allocationInProgress.owner = clearingSelectionInfo.owner;
      // console.log("------> clearingSelectionInfo "+JSON.stringify(clearingSelectionInfo));
      allocationInProgress.clearingHouse = clearingSelectionInfo.clearingHouse;
      allocationInProgress.exchangeCode = clearingSelectionInfo.exchangeCode;
      allocationInProgress.execTrader = clearingSelectionInfo.operatorId;
      allocationInProgress.traderMemo = clearingSelectionInfo.freeText2;
      this.originTraderMemo = clearingSelectionInfo.freeText2;
    }
    allocationInProgress.accountTypeCode = AccountType.GIVE_UP_CODE;
    allocationInProgress['formContractsCodes'] = new Set(clearingSelectionInfos.map(value => value.contract));
    this.openWithRecord(allocationInProgress);
    // }
  }

  public openWithRecord(newFormRecord: AllocationRequest): void {
    this.formRecord = newFormRecord;
    this.formContractsCodes = newFormRecord['formContractsCodes'];
    this.loadData();
    // this.filterCustomers();
    // this.filterAccounts();
    // this.filterAccountTypes();
    this.loadFooterInfos(this.formRecord.tradeIds);
    this.show();
  }

  protected doSave() {
    this.formLoading = true;
    if (this.manageGiveUpMssg23()) {
      this.formRecord.broker = this.formRecord.giveUpMessage3;
    }
    this.allocationService.singleAllocationRequest(this.formRecord).subscribe(validation => {
      if (validation.success) {
        this.onSavedForm.emit({taskId: validation.item, formRecord: Object.assign({}, this.formRecord)});
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  protected getSelectionSummary(summaryRequest: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionSummary[]>> {
    return this.clearingTradeInfoService.getSelectionSummary(summaryRequest);
  }

}

